<div class="vh">
  <div class="row">
    <title
      direction="center"
      [style]="{ color: '#3376F6', 'text-align': 'center' }"
    >
      Merci ! Nous vous connaissons mieux.
    </title>
    <profile-box></profile-box>
    <title direction="center" [style]="{ 'text-align': 'center' }">
      Nous avons besoin de connaître votre profil investisseur et quels risques
      vous êtes prêts à prendre.
    </title>
  </div>
</div>
<ng-container>
  <div class="btn-group">
    <pr-button
      size="lg"
      type="button"
      label="Question précédente"
      icon="arrow_left"
      (onClick)="prev()"
    ></pr-button>
    <pr-button
      size="lg"
      type="submit"
      display="neutral"
      label="Je détermine mon profil."
      (onClick)="next()"
    ></pr-button>
  </div>
</ng-container>
